import { lazy } from 'react';
import { Switch, useRouteMatch } from 'react-router-dom';
import { AnnotationToolRoute } from 'packages/main/routes/components/annotation-tool-route';

const ErrorPage404 = lazy(
  () => import('packages/lib/common-ui/error-pages/error-page-404')
);
const LidarTool = lazy(() => import('packages/main/pages/lidar-box-legacy'));

export function RAILRoutes(): JSX.Element {
  const match = useRouteMatch();
  return (
    <Switch>
      <AnnotationToolRoute
        path={`${match.url}/:mode(qa|QA|label|LABEL|view|VIEW)/:lidarExtractionToken`}
        exact
      >
        <LidarTool />
      </AnnotationToolRoute>
      <AnnotationToolRoute>
        <ErrorPage404 />
      </AnnotationToolRoute>
    </Switch>
  );
}

export default RAILRoutes;
